import { Loader2 } from "lucide-react"

export default function Spinner({ className = "" }) {
  return <Loader2 className={`animate-spin ${className}`} />
}

// A centered spinner filling the space below the nav, for whole-page loads
// (initial session check, first fetch on a list page, etc).
export function PageSpinner() {
  return (
    <div className="flex min-h-[50vh] items-center justify-center">
      <Spinner className="size-6 text-muted-foreground" />
    </div>
  )
}
